export default "__VITE_ASSET__2b6ee9a6__"